import { ComponentProps } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router'

import typeStyle from 'styles/typeStyle'

import AdventureCard from '../../../components/cards/AdventureCard'
import AdventurePlaceholderCard from '../../../components/cards/AdventureCard/Placeholder'
import AddRemoveButton from '../../../dashboard/MyBookings/ItineraryBuilder/AddRemoveButton'

const AddRemoveButtonWrapper = styled.div`
  ${typeStyle('-ds-font-body-regular')}
`

type SuggestedAdventureCardProps = ComponentProps<typeof AdventureCard> & {
  id: string
  inItineraryContext?: boolean
  hideStoryteller?: boolean
  noLink?: boolean
}

export const LoadingCard = () => <AdventurePlaceholderCard />

const SuggestedAdventureCard = ({
  id,
  title,
  photos,
  storyteller,
  location,
  inItineraryContext,
  reviewScore,
  showReviewScore,
  onSelectEscapeClick,
  isInEscape,
  url: directUrl,
  hideStoryteller,
  noLink,
}: SuggestedAdventureCardProps) => {
  const { pathname } = useLocation()
  let url = inItineraryContext ? `${pathname}/${id}` : directUrl

  if (noLink) {
    url = undefined
  }

  return (
    <>
      <AdventureCard
        title={title}
        photos={photos}
        storyteller={!hideStoryteller && storyteller}
        location={location}
        url={url}
        reviewScore={reviewScore}
        showReviewScore={showReviewScore}
        onSelectEscapeClick={onSelectEscapeClick}
        isInEscape={isInEscape}
        actions={
          inItineraryContext && (
            <AddRemoveButtonWrapper>
              <AddRemoveButton adventureId={id} />
            </AddRemoveButtonWrapper>
          )
        }
      />
    </>
  )
}

export default SuggestedAdventureCard
